import { render, staticRenderFns } from "./Scene.vue?vue&type=template&id=104a24cd&"
import script from "./Scene.vue?vue&type=script&lang=js&"
export * from "./Scene.vue?vue&type=script&lang=js&"
import style0 from "./Scene.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports